/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_No_ListingsInputs */

const cs_public_site_no_listings = /** @type {(inputs: Public_Site_No_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Momentálně nemáme žádné aktivní nabídky.`)
};

const en_public_site_no_listings = /** @type {(inputs: Public_Site_No_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are no active listings right now.`)
};

/**
* | output |
* | --- |
* | "There are no active listings right now." |
*
* @param {Public_Site_No_ListingsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_no_listings = /** @type {((inputs?: Public_Site_No_ListingsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_No_ListingsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_no_listings(inputs)
	return cs_public_site_no_listings(inputs)
});